module.exports = __webpack_public_path__ + "img/2.821e3340.png";